import { Card, Col, Row, Typography, theme as antdTheme } from 'antd';
import {
  AlertOutlined,
  DollarOutlined,
  PlayCircleOutlined,
  PrinterOutlined,
  RightOutlined,
  TableOutlined,
  TagsOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router';
import { PageHeader } from '@/shared/components/page-header';

interface Tile {
  to: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const tiles: Tile[] = [
  {
    to: '/fee/collect',
    title: 'Collect payment',
    description: 'Find a student, see what they owe at a glance, record a receipt, hand over a printed copy.',
    icon: <DollarOutlined />,
  },
  {
    to: '/fee/structures',
    title: 'Fee structures',
    description: 'Per (year × class·section × fee type) amounts. Define what each class pays.',
    icon: <TableOutlined />,
  },
  {
    to: '/fee/generate',
    title: 'Generate invoices',
    description: 'Run monthly invoice generation for a class·section. Re-runs are safe — existing invoices are skipped.',
    icon: <PlayCircleOutlined />,
  },
  {
    to: '/fee/types',
    title: 'Fee types',
    description: 'Tuition, admission, exam, lab… each with a frequency (monthly / one-time / per-term).',
    icon: <TagsOutlined />,
  },
  {
    to: '/fee/defaulters',
    title: 'Defaulters',
    description: 'List students whose months-due or outstanding amount crosses a threshold.',
    icon: <AlertOutlined />,
  },
  {
    to: '/fee/vouchers',
    title: 'Print fee vouchers',
    description: 'Bulk-print 3-copy challans (Bank · School · Student) for a class · section and month.',
    icon: <PrinterOutlined />,
  },
];

export function FeeHubPage() {
  const { token } = antdTheme.useToken();
  return (
    <div style={{ display: 'grid', gap: 22 }}>
      <PageHeader
        eyebrow="Module"
        title="Fee management"
        description="Structures, invoices, payments, and defaulters. Discounts attach per student per fee type."
      />

      <Row gutter={[16, 16]}>
        {tiles.map((t) => (
          <Col key={t.to} xs={24} md={12} xl={6}>
            <Link to={t.to} style={{ textDecoration: 'none' }}>
              <Card
                hoverable
                className="lift-card"
                style={{ height: '100%', borderColor: token.colorBorderSecondary }}
                styles={{ body: { padding: 20 } }}
              >
                <div style={{ display: 'flex', gap: 14 }}>
                  <span
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      display: 'grid',
                      placeItems: 'center',
                      background: token.colorFillTertiary,
                      color: token.colorPrimary,
                      fontSize: 18,
                      flexShrink: 0,
                    }}
                  >
                    {t.icon}
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                      <Typography.Text strong style={{ fontSize: 15 }}>
                        {t.title}
                      </Typography.Text>
                      <RightOutlined style={{ fontSize: 12, color: token.colorTextTertiary }} />
                    </div>
                    <Typography.Text type="secondary" style={{ fontSize: 13, display: 'block', marginTop: 4 }}>
                      {t.description}
                    </Typography.Text>
                  </div>
                </div>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
